import { hasManualTradingOrigin } from '@/config/api';

const STORAGE_KEY = 'octopus:data-fe:access-token';

let accessToken: string | null = null;

export function getAccessToken(): string | null {
  if (accessToken) return accessToken;
  if (typeof sessionStorage !== 'undefined' && hasManualTradingOrigin()) {
    const persisted = sessionStorage.getItem(STORAGE_KEY);
    if (persisted) {
      accessToken = persisted;
    }
  }
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
  if (typeof sessionStorage === 'undefined') return;
  if (hasManualTradingOrigin() && token) {
    sessionStorage.setItem(STORAGE_KEY, token);
  } else {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}

export function clearAccessToken(): void {
  accessToken = null;
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}
